import React from 'react'
import { Translate } from 'react-redux-i18n'
import { connect } from 'react-redux'

const CheckInTypeError = ({ show }) => {
  if (show)
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4 flex items-start">
        <svg
          className="w-5 h-5 text-red-600 mr-2 flex-shrink-0 mt-0.5"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
        <span className="text-red-800 text-sm font-medium">
          <Translate value="checkInScene.checkInType.nullMsg" />
        </span>
      </div>
    )
  return null
}

export default connect(({ checkin }) => ({
  show: checkin.errors.checkInType !== undefined && checkin.touch.checkInType,
}))(CheckInTypeError)
